import store from '~/store'
import Vue from 'vue'
import i18n from '~/plugins/i18n'

export default (to, from, next) => {
  if (!store.getters['auth/showWholesalePrice']) {
    Vue.$toast.warning(i18n.t('wholesale_price_required_order'))
    next({ name: 'order-history.index' })
  } else {
    next()
  }
}
